import { render, staticRenderFns } from "./SaveChangesAlert.vue?vue&type=template&id=515fcd9a&"
import script from "./SaveChangesAlert.vue?vue&type=script&lang=js&"
export * from "./SaveChangesAlert.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports